/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Start_Review_Aria_LabelInputs */

const en_style_guide_start_review_aria_label = /** @type {(inputs: Style_Guide_Start_Review_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Review`)
};

const fr_style_guide_start_review_aria_label = /** @type {(inputs: Style_Guide_Start_Review_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demarrer l'examen`)
};

const de_style_guide_start_review_aria_label = /** @type {(inputs: Style_Guide_Start_Review_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertung starten`)
};

const it_style_guide_start_review_aria_label = /** @type {(inputs: Style_Guide_Start_Review_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia la revisione`)
};

const ru_style_guide_start_review_aria_label = /** @type {(inputs: Style_Guide_Start_Review_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать обзор`)
};

const es_style_guide_start_review_aria_label = /** @type {(inputs: Style_Guide_Start_Review_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar revisión`)
};

const zh_cn2_style_guide_start_review_aria_label = /** @type {(inputs: Style_Guide_Start_Review_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始评论`)
};

const ja_style_guide_start_review_aria_label = /** @type {(inputs: Style_Guide_Start_Review_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レビューを開始`)
};

const hi_style_guide_start_review_aria_label = /** @type {(inputs: Style_Guide_Start_Review_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समीक्षा शुरू करें`)
};

const pt_pt2_style_guide_start_review_aria_label = /** @type {(inputs: Style_Guide_Start_Review_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar avaliação`)
};

/**
* | output |
* | --- |
* | "Start Review" |
*
* @param {Style_Guide_Start_Review_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_start_review_aria_label = /** @type {((inputs?: Style_Guide_Start_Review_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Start_Review_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_start_review_aria_label(inputs)
	if (locale === "de") return de_style_guide_start_review_aria_label(inputs)
	if (locale === "it") return it_style_guide_start_review_aria_label(inputs)
	if (locale === "ru") return ru_style_guide_start_review_aria_label(inputs)
	if (locale === "es") return es_style_guide_start_review_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_start_review_aria_label(inputs)
	if (locale === "ja") return ja_style_guide_start_review_aria_label(inputs)
	if (locale === "hi") return hi_style_guide_start_review_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_start_review_aria_label(inputs)
	return en_style_guide_start_review_aria_label(inputs)
});